import CardMedia from '@mui/material/CardMedia';
import React, { useEffect, useState } from 'react';
import { AdContentTO } from './use-adserveContent';

type Props = {
  data?: AdContentTO;
  isVisible?: boolean;
};

export function AdVideoContent(props: Props) {
  const { data, isVisible } = props;
  const [isViewed, setIsViewed] = useState(false);

  useEffect(() => {
    setIsViewed(isVisible ?? false); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.banner_id]);

  useEffect(() => {
    if (isVisible) {
      setIsViewed(true);
    }
  }, [isVisible]);
  return (
    <>
      {data && (
        <>
          <div
            className="optanon-category-C0004"
            dangerouslySetInnerHTML={{ __html: data.body }}
          />
          <CardMedia
            component="img"
            image={data.accupixel_url}
            style={{
              display: 'none',
              height: '1',
              width: '1',
            }}
          />

          <CardMedia
            component="img"
            image={data.eligible_url}
            style={{
              display: 'none',
              height: '1',
              width: '1',
            }}
          />

          {isViewed && (
            <CardMedia
              component="img"
              image={data.viewable_url}
              style={{
                display: 'none',
                height: '1',
                width: '1',
              }}
            />
          )}
        </>
      )}
    </>
  );
}
